export default "/kiban/_next/static/images/vcutCnt-f2aa931f1b9d3ad1f41f0c5c625a1ed6.png";